import {Injectable} from '@angular/core';
import {userPermissionsStore} from './user-permissions.store';
import {Observable} from 'rxjs';
import {DashboardAccessMap} from '../../../../userway/sdk/UserWayApiClient';
import {select} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class UserPermissionsQuery {
  public userPermissions$: Observable<DashboardAccessMap>;

  constructor() {
    this.userPermissions$ = userPermissionsStore.pipe(select(state => state));
  }
}
